/**
 * Lista partilhada das empresas da pessoa.
 *
 * Vive fora do React para o menu, a barra e o início pedirem uma vez só, e
 * para o fim de sessão a poder limpar sem importar o hook (esse importa o
 * contexto de autenticação — o ciclo partia o arranque).
 *
 * A lista que já se conhece fica. Um erro de rede não a substitui por vazia:
 * vazio significa «não tem empresa», e era isso que escondia o único atalho.
 */
import api from '../utils/api';

let estado = { id: null, lista: null, pedido: null, versao: 0 };
const ouvintes = new Set();
let repeticao = null;
let falhas = 0;

function avisar() {
  ouvintes.forEach((fn) => fn());
}

function cancelarRepeticao() {
  if (!repeticao) return;
  clearTimeout(repeticao);
  repeticao = null;
}

export function versaoMinhasEmpresas() {
  return estado.versao;
}

export function listaEmCache(id) {
  if (!id || estado.id !== id || !Array.isArray(estado.lista)) return null;
  return estado.lista;
}

export function subscreverMinhasEmpresas(fn) {
  ouvintes.add(fn);
  return () => ouvintes.delete(fn);
}

export function invalidarMinhasEmpresas() {
  cancelarRepeticao();
  falhas = 0;
  estado = { id: null, lista: null, pedido: null, versao: estado.versao + 1 };
  avisar();
}

/** Uma falha não é o fim: volta a pedir, com mais tempo se insistir. */
export function repetirMinhasEmpresas() {
  if (repeticao) return;
  falhas += 1;
  const espera = Math.min(30000, 4000 * falhas);
  repeticao = setTimeout(() => {
    repeticao = null;
    estado = { ...estado, pedido: null, versao: estado.versao + 1 };
    avisar();
  }, espera);
}

export function pedirMinhasEmpresas(id) {
  if (!id) return Promise.resolve([]);
  if (estado.id === id && estado.pedido) return estado.pedido;

  const versao = estado.versao;
  const pedido = api.get('/businesses/mine').then((r) => {
    const empresas = Array.isArray(r.data) ? r.data : [];
    // Logout ou empresa acabada de criar: o pedido antigo já não manda.
    if (estado.versao !== versao) return empresas;
    cancelarRepeticao();
    falhas = 0;
    estado = { id, lista: empresas, pedido: null, versao };
    return empresas;
  }).catch((err) => {
    if (estado.versao === versao && estado.pedido === pedido) {
      estado = { ...estado, pedido: null };
    }
    throw err;
  });

  estado = {
    id,
    lista: estado.id === id ? estado.lista : null,
    pedido,
    versao,
  };
  return pedido;
}
